// ส่วนที่ใช้ร่วมกันของแท็บต่างๆ ในหน้า ผู้ดูแลระบบ > สถิติการใช้งาน
import React from "react";
import { Card, Col, Table } from "react-bootstrap";

// MySQL คืนค่าจาก SUM()/COUNT() บางตัวเป็น string (DECIMAL) — ต้องแปลงก่อนคำนวณเสมอ
export const num = (value) => Number(value) || 0;

export const RANGE_OPTIONS = [
  { value: 7,   label: '7 วันล่าสุด' },
  { value: 30,  label: '30 วันล่าสุด' },
  { value: 90,  label: '90 วันล่าสุด' },
  { value: 180, label: '180 วันล่าสุด' },
];

export const DEVICE_LABEL  = { desktop: 'คอมพิวเตอร์', mobile: 'มือถือ', tablet: 'แท็บเล็ต', other: 'อื่นๆ' };
export const SOURCE_LABEL  = { staff: 'บุคลากร', portal: 'พอร์ทัลนักเรียน' };
export const REASON_LABEL  = {
  no_user:      'ไม่มีรหัสผู้ใช้นี้',
  bad_password: 'รหัสผ่านไม่ถูกต้อง',
  rate_limited: 'ถูกจำกัดจำนวนครั้ง',
  unknown:      'ไม่ระบุ',
};

// รหัสประเทศ ISO 2 ตัว -> ชื่อภาษาไทย ด้วย Intl ที่ติดมากับเบราว์เซอร์
// (เซิร์ฟเวอร์ใช้วิธีเดียวกันใน server/utils/countryNames.js — ไม่ต้องมีตารางชื่อประเทศให้ดูแล)
const regionNames = (() => {
  try { return new Intl.DisplayNames(['th'], { type: 'region' }); } catch { return null; }
})();

// 'unknown' คือค่าที่ server ส่งมาแทน NULL ซึ่งไม่ได้แปลว่า "ไม่มีประเทศ" แต่แปลว่า
// ยังไม่รู้ — เป็นที่อยู่ในวงภายใน หรือยังไม่ได้ติดตั้งฐานข้อมูล GeoIP บนเซิร์ฟเวอร์
export const UNKNOWN_COUNTRY = 'unknown';

// ประเทศที่ถือว่าปกติ ใช้ตัดสินว่าจะเน้นสีแถวไหน — ต้องตรงกับ GEOIP_HOME_COUNTRY
// ใน server/.env (ค่าเริ่มต้นเหมือนกันคือ TH) การนับจริงทำที่ server เสมอ
export const HOME_COUNTRY = 'TH';

export const countryName = (code) => {
  if (!code || code === UNKNOWN_COUNTRY) return 'ไม่ทราบที่ตั้ง';
  const upper = String(code).toUpperCase();
  try { return regionNames?.of(upper) || upper; } catch { return upper; }
};

// 2026-09-04 -> 04/09/2026 (ให้ตรงกับรูปแบบวันที่อื่นในหน้านี้ ซึ่ง server format มาแล้ว)
export const formatDate = (iso) => {
  const [y, m, d] = String(iso || '').split('-');
  return y ? `${d}/${m}/${y}` : '—';
};

export const formatHour = (hour) => `${String(hour).padStart(2, '0')}:00 - ${String(hour).padStart(2, '0')}:59`;

export const StatTile = ({ label, value, variant = 'dark', hint }) => (
  <Col xs={6} md={3}>
    <Card className="card-one h-100">
      <Card.Body className="p-3">
        <div className="text-secondary fs-xs mb-1">{label}</div>
        <h3 className={`mb-0 text-${variant}`}>{value}</h3>
        {hint && <div className="text-secondary fs-xs mt-1">{hint}</div>}
      </Card.Body>
    </Card>
  </Col>
);

// ตารางสัดส่วน เช่น ระบบปฏิบัติการ / เบราว์เซอร์ — แสดงจำนวนพร้อมเปอร์เซ็นต์ของยอดรวม
export const DistributionTable = ({ title, rows, labelMap, emptyText = 'ยังไม่มีข้อมูล' }) => {
  const total = rows.reduce((sum, r) => sum + num(r.total), 0);
  return (
    <Card className="card-one h-100">
      <Card.Header><Card.Title as="h6" className="mb-0">{title}</Card.Title></Card.Header>
      <Card.Body className="p-0">
        {rows.length === 0 ? (
          <div className="text-center text-secondary py-4 fs-sm">{emptyText}</div>
        ) : (
          <Table hover className="mb-0">
            <tbody>
              {rows.map((r) => (
                <tr key={r.name}>
                  <td>{labelMap?.[r.name] || r.name}</td>
                  <td className="text-end text-nowrap" style={{ width: 80 }}>{num(r.total).toLocaleString()}</td>
                  <td className="text-end text-secondary fs-sm text-nowrap" style={{ width: 70 }}>
                    {total ? `${Math.round((num(r.total) / total) * 100)}%` : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};
